import axios from 'axios';


const api_base_url = "https://deliverybackend.com/frootwheelapi/V1"

var openapi_server = axios.create({
    baseURL: api_base_url,
    headers: {
        'Content-Type': 'application/json'
    }
});

const getConfig = headerparams => { return { headers: { 'authorization': localStorage.getItem('lvlacc') || 'newnlp', ...headerparams } }; };



export const checkCode = (params, headerparams) => {

    var myformData = new FormData();

    myformData.set('f', 'checkcode');
    myformData.set('code', params.code);

    return openapi_server.post(
        `frootwheelapi.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const spinTheWheel = (params, headerparams) => {

    var myformData = new FormData();

    myformData.set('f', 'spinwheel');
    myformData.set('code', params.code);
    myformData.set('name', params.name);
    myformData.set('phone', params.phone);
    myformData.set('payout_method', params.payout_method);
    myformData.set('payout_handle', params.payout_handle);

    return openapi_server.post(
        `frootwheelapi.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getWinnerVideo = (params, headerparams, onProgress) => {
    var myformData = new FormData();
    myformData.set('f', 'getfile');
    myformData.set('vcode', params.vcode);
    var config = getConfig({'Content-Type': 'multipart/form-data',...headerparams});
    if (onProgress) {
        config.onDownloadProgress = onProgress;
    }
    return openapi_server.post(
        `getfile.php`,
        myformData,
        config
    )
}

export const submitPayout = (params, headerparams) => {

    var myformData = new FormData();

    myformData.set('f', 'submitpayout');
    myformData.set('code', params.code);
    myformData.set('instagram', params.instagram);
    myformData.set('payout_method', params.payout_method);
    myformData.set('payout_handle', params.payout_handle);
    myformData.set('win_dollar', params.win_dollar);

    return openapi_server.post(
        `frootwheelapi.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const stageLog = (params, headerparams) => {

    var myformData = new FormData();

    myformData.set('f', 'stagelog');
    myformData.set('code', params.code);
    myformData.set('stage', params.stage);

    openapi_server.post(
        `frootwheelapi.php`,
        myformData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    ).catch(() => {})
}
